import * as React from "react";
import {MouseEvent} from "react";
import {prettyPrintLike} from "../../_helpers/utils";
import * as classNames from "classnames";
import {PrimaryModels} from "../../_definitions/styleteq";
import {connect} from "react-redux";
import LikeComponent from "./LikeComponent";
import {toggleLike} from "../../_data/middlewares";
import {currentUserIdSelector} from "../../user/selectors";
import {push} from "react-router-redux";
import {UsersRoutes} from "../../routes";

interface Props {
    model: PrimaryModels;
    isGalleryView?: boolean;
}

const mapStateToProps = (state, props) => {
    const {model, isGalleryView} = props;

    return {
        likable: model as Likable,
        isGalleryView: isGalleryView,
        currentUserID: currentUserIdSelector(state)
    }
};

const mapDispatchToProps = (dispatch, props) => {
    const {model} = props;

    return {
        toggleLike: (e: MouseEvent<HTMLElement>, id:number) => {
            e.stopPropagation();
            if(!id)
                return window.location.href = UsersRoutes.sign_in();
            return dispatch(toggleLike(model));
        }
    }
};

const LikeContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(LikeComponent);
export default LikeContainer;


// WEBPACK FOOTER //
// ./app/client/_widgets/like/LikeContainer.tsx